import { useState } from 'react';
import { Flex, Text, Button, Tooltip, IconButton } from '@radix-ui/themes';
import { useTranslation } from 'react-i18next';
import styles from './manage_categories.module.css';

export const CategoryListItem = ({
  category,
  onEdit,
  onDelete,
  isUpdating,
}) => {
  const { t } = useTranslation('vault');
  const [confirmDelete, setConfirmDelete] = useState(false);

  const isOther = category.name === 'Other';

  const handleDelete = async () => {
    await onDelete(category.id);
    setConfirmDelete(false);
  };

  return (
    <div className={styles.categoryItem}>
      <div className={styles.categoryIcon}>
        <i className={`fa-regular ${category.icon || 'fa-folder'}`} />
      </div>
      <Text size="2" weight="medium" className={styles.categoryName}>
        {category.name}
      </Text>
      <Text size="1" color="gray">
        {t('fileCount', { count: category.fileCount })}
      </Text>
      <div className={styles.categoryActions}>
        {!isOther && (
          <>
            <Tooltip content={t('editCategory')}>
              <IconButton
                variant="outline"
                size="2"
                color="gray"
                onClick={() => onEdit(category)}
              >
                <i className="fa-light fa-pen-to-square fa-lg" />
              </IconButton>
            </Tooltip>
          </>
        )}

        {!isOther &&
          (confirmDelete ? (
            <Flex gap="2" align="center">
              <Button
                size="1"
                variant="outline"
                onClick={() => setConfirmDelete(false)}
              >
                {t('cancel')}
              </Button>
              <Button
                size="1"
                variant="solid"
                color="red"
                onClick={handleDelete}
                disabled={isUpdating}
              >
                {t('confirm')}
              </Button>
            </Flex>
          ) : (
            <Tooltip content={t('deleteCategory')}>
              <IconButton
                variant="outline"
                size="2"
                color="gray"
                onClick={() => setConfirmDelete(true)}
              >
                <i className="fa-light fa-trash fa-lg" />
              </IconButton>
            </Tooltip>
          ))}
      </div>
    </div>
  );
};
